import React, {Component} from 'react';
import {Button, Layout, Typography} from "antd";
import OpenSheetMusicDisplay from "../../components/OpenSheetMusicDisplay";
import MIDISounds from 'midi-sounds-react';
import {CaretRightOutlined} from '@ant-design/icons';
import {intervals} from './intervals';
import {intervalNames} from "./helper";
import {MidiPlayer} from "./MidiPlayer";
import {MusicXml} from "./MusicXml";

const {Content} = Layout;

export default class IntervalsContainer extends Component {

    getCode = (item) => {
        const index = intervalNames.findIndex(interval => interval.name === item.name);
        if (index >= 0) {
            return intervalNames[index].code;
        }
        return '';
    }

    render() {
        return <Layout style={{background: '#fff', margin: '0 24px', padding: '0'}}>
            <Content style={{padding: '12px'}}>
                <div style={{textAlign: 'left'}}>
                    <Typography.Title level={3} style={{textTransform: 'uppercase', margin: '0'}}>
                        Nazwy interwałów
                    </Typography.Title>

                    <p style={{marginTop: '16px'}}>
                        Interwał jest to odległość między dwoma dźwiękami.
                        Nazwy interwałów pochodzą od łacińskich nazw liczebników i określają liczbę stopni zawartych
                        między dźwiękami tworzącymi dany interwał, wraz z tymi dźwiękami.
                    </p>

                    <div style={{display: 'none'}}>
                        <MIDISounds
                            ref={(ref) => (this.midiSounds = ref)}
                            appElementName="root" instruments={[3]}
                        />
                    </div>

                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center'}}>
                        {intervals.map((item, key) => {
                            return <div key={key} style={{width: '300px', textAlign: 'center'}}>
                                <OpenSheetMusicDisplay
                                    file={MusicXml.buildIntervalMusicXML(item)}
                                    drawTitle={false}
                                    autoResize={true}
                                    backend={'svg'}
                                    drawPartNames={false}
                                    drawCredits={false}
                                    stretchLastSystemLine={true}
                                />
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '5px'
                                }}>
                                    <Button icon={<CaretRightOutlined/>}
                                            onClick={() => MidiPlayer.playInterval(this.midiSounds, item)}></Button>
                                    <div>{item.name} ({this.getCode(item)})</div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </Content>
        </Layout>
    }
}
